import "./styles.scss";
import { mdWithLinks } from "utils";

export default function Cookies(lsm) {
  const cookies = Boolean(lsm.get("cookies"));

  if (!cookies) {
    const container = document.createElement("div");
    container.className =
      "pie-cookies pie-message info shadow stack styled-links --p";
    container.innerHTML = `
      <div class="stack --gap-sm">
        <p class="chalk-font font-lg">${pie_i18n.PIE_JS_COOKIES_HEADER}</p>
        <p>${mdWithLinks(pie_i18n.PIE_JS_COOKIES_CONTENT_MD)}</p>
      </div>
      <button class="pie-button violet text-white --push-right">
        <span>${pie_i18n.PIE_JS_COOKIES_ACCEPT_LABEL}</span>

      </button>
    `;

    container.addEventListener("click", (event) => {
      if (event.target.tagName === "BUTTON") {
        lsm.set("cookies", true);
        container.remove();
      }
    });

    document.body.append(container);
  }
}
